export const JunkRemovalHeroSection = () => {
  return (
    <section className="relative bg-gray-900 text-white py-20 md:py-32">
      {/* Background image overlay - same as homepage */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('/redebins/images/hero-background.jpg')",
          }}
        />
        <div className="absolute inset-0 bg-black/10" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Phone number at top */}
          <a
            href="tel:9529312577"
            className="text-2xl md:text-3xl font-bold text-[#E31837] hover:underline block mb-4"
          >
            952-931-2577
          </a>
          <h1 className="text-4xl md:text-6xl font-bold mb-4 italic">
            RED-E REMOVAL
          </h1>
        </div>
      </div>
    </section>
  );
};

